<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  weight: {
    type: Number,
    required: true,
  },
  barClass: {
    type: String,
    default: 'bg-n-slate-9',
  },
});

const { t } = useI18n();

const filledBars = computed(() => {
  if (props.weight >= 0.4) return 3;
  if (props.weight >= 0.3) return 2;
  return 1;
});

const weightPercent = computed(() => Math.round(props.weight * 100));

const impactLabel = computed(() =>
  t('BUZZ_REPORTS.FORMULA.WEIGHT', { percent: weightPercent.value })
);
</script>

<template>
  <span
    class="inline-flex h-3.5 w-7 items-end justify-end gap-0.5 shrink-0"
    :title="impactLabel"
    :aria-label="impactLabel"
    role="img"
  >
    <span
      v-for="index in 3"
      :key="index"
      class="w-1 rounded-sm"
      :class="[
        barClass,
        index === 1 ? 'h-1.5' : index === 2 ? 'h-2.5' : 'h-3.5',
        index <= filledBars ? 'opacity-100' : 'opacity-20',
      ]"
    />
  </span>
</template>
